import gsap from 'gsap'

import {
  buttonRevealAnimation,
  fadeImageAnimation,
  SharedAnimation,
  titleRevealAnimation
} from './shared'
import { Animation } from '@/types'

export const projectsBlock = ({
  node,
  reverse,
  mobile,
  context
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const image = selector('[data-motion-image]')[0]
  const title = selector('[data-motion-title]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]
  const cta = selector('[data-motion-cta]')[0]

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let imageAnimation: SharedAnimation
  if (image) {
    imageAnimation = fadeImageAnimation(image)
    timeline.add(imageAnimation.timeline, '<')
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = titleRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<+0.2')
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = titleRevealAnimation(paragraph, reverse)
    timeline.add(paragraphAnimation.timeline, '<+0.4')
  }

  let ctaAnimation: SharedAnimation
  if (cta) {
    ctaAnimation = buttonRevealAnimation(cta)
    timeline.add(ctaAnimation.timeline, '<+0.6')
  }

  return () => {
    if (imageAnimation) {
      imageAnimation.revert()
    }
    if (titleAnimation) {
      titleAnimation.revert()
    }
    if (paragraphAnimation) {
      paragraphAnimation.revert()
    }
    if (ctaAnimation) {
      ctaAnimation.revert()
    }
  }
}
